import React from 'react';
import { RiBankCard2Fill } from "react-icons/ri";
import { MdSms } from "react-icons/md";
import { PiBankLight } from "react-icons/pi";
import { TbNetwork } from "react-icons/tb";
import { BiTransferAlt } from "react-icons/bi";
import { BiQrScan } from "react-icons/bi";
import { FaUniversity } from "react-icons/fa";

function Neft() {
    const services = [
        {
            icon: <PiBankLight />,
            title: 'Core Banking & Digital Services',
            desc: (
                <>
                    We have adopted the Core Banking System (CBS) to offer efficient, real-time banking services. To enhance customer convenience, we also provide the following digital facilities:
                    <ul className="mt-3 ps-3 mb-0" style={{ listStyleType: 'disc' }}>
                        <li><MdSms className="me-1 text-danger" /> <strong>SMS Banking:</strong> Stay updated on your account activities through instant SMS alerts.</li>
                        <li><BiTransferAlt className="me-1 text-danger" /> <strong>Online Fund Transfers:</strong> Enjoy easy and secure RTGS and NEFT services.</li>
                        <li><BiQrScan className="me-1 text-danger" /> <strong>Dynamic QR Code Payments:</strong> Make seamless payments via QR code-based solutions.</li>
                    </ul>
                </>
            )
        },
        {
            icon: <BiTransferAlt />,
            title: 'RTGS & NEFT Services',
            desc: 'We offer RTGS (Real Time Gross Settlement) and NEFT (National Electronic Funds Transfer) facilities, maintained by the Reserve Bank of India, enabling safe and reliable money transfers within the country. These systems allow fast fund movement between banks for individuals and businesses.'
        },
        {
            icon: <MdSms />,
            title: 'SMS Alert Facility',
            desc: 'Stay informed, stay secure! With our SMS Alert Facility, you receive real-time updates on your account transactions directly on your registered mobile number. Be notified of every credit, debit, or change in your account instantly.'
        },
        {
            icon: <TbNetwork />,
            title: 'Branch Network',
            desc: (
                <>
                    To ensure we are always close to our customers, the bank currently operates five fully functional branches across Thrissur:
                    <ul className="mt-3 ps-3 mb-0" style={{ listStyleType: 'disc' }}>
                        <li>Kurichikkara (Main Branch)</li>
                        <li>Thanikkudam</li>
                        <li>Kuttumuck</li>
                        <li>Cheroor</li>
                        <li>Puthenvettuvazhy</li>
                    </ul>
                </>
            )
        },
        {
            icon: <RiBankCard2Fill />,
            title: 'Loan Facilities',
            desc: 'From gold loans to housing loans, our offerings are tailored to suit every financial need.'
        },
    ];

    return (
        <div className='py-5' style={{ backgroundColor: '#f7f9fc' }}>
            <div className='container'>
                <div className='row g-4 align-items-start flex-column-reverse flex-md-row'>
                    {/* Left - Accordion Services */}
                    <div className='col-md-6'>
                        <div className="accordion" id="serviceAccordion">
                            {services.map((service, index) => (
                                <div className="accordion-item" key={index}>
                                    <h2 className="accordion-header" id={`heading${index}`}>
                                        <button
                                            className="accordion-button fw-bold"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse${index}`}
                                            aria-expanded={index === 0 ? "true" : "false"}
                                            aria-controls={`collapse${index}`}
                                            style={{
                                                backgroundColor: index % 2 === 0 ? '#e74c3c' : '#ffffff',
                                                color: index % 2 === 0 ? '#fff' : '#333',
                                            }}
                                        >
                                            <span className="me-2">{service.icon}</span>
                                            {service.title}
                                        </button>
                                    </h2>
                                    <div
                                        id={`collapse${index}`}
                                        className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                                        aria-labelledby={`heading${index}`}
                                        data-bs-parent="#serviceAccordion"
                                    >
                                        <div className="accordion-body" style={{ backgroundColor: index % 2 === 0 ? '#fdecea' : '#f9f9f9' }}>
                                            {service.desc}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right - Loan Services */}
                    <div className='col-md-6'>
                        <div className="p-4 rounded shadow-lg" style={{ backgroundColor: '#e74c3c', color: '#fff' }}>
                            <h4 className="fw-bold mb-3">Loan Services</h4>
                            <p>
                                Our bank provides a wide range of loan products to support personal, agricultural, and business needs.
                                We now offer loan facilities up to <strong>Rs.10 lakhs</strong>, with competitive interest rates and flexible repayment options.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Neft;
